import collapse from './collapse';
import highlight from './highlight';
import scroll from './scroll';

export default Object.assign({},
    collapse,
    highlight,
    scroll
);


// WEBPACK FOOTER //
// ./src/interaction/index.js